import { getDateAndTimeFormat } from '@/utils/utils';
import moment from 'moment';

export const spaceName = 'odDishes';
export interface DishesSettings {
  viewMode: 'gridView' | 'listView';
  selectedIds: Number[];
  currentPageInfo: {
    data: any;
    params: {
      currentPage: Number;
      pageSize: Number;
      total: Number;
    };
  };
  searchItem: string | false;
  sortItem:
    | {
        sortedBy: string;
        sortedOrder: 'ascend' | 'descend' | false;
      }
    | false;
  filter:
    | {
        offeringType: any[];
        tag: any[];
      }
    | false;
}

export default {
  viewMode: 'gridView',
  selectedIds: [],
  currentPageInfo: {
    data: [],
    params: {
      currentPage: 1,
      pageSize: 12,
      total: 0,
    },
  },
  searchItem: false,
  sortItem: false,
  filter: false,
} as DishesSettings;

//config for the listViewColumns
export const getListViewColumns = (props: any) => {
  const {
    od: {
      offeringTypeList,
      tagList: { ingredient },
    },
    actionButton,
    publish,
    stock,
    helper: { tx },
    price,
    [spaceName]: { sortItem, filter },
  } = props;

  const validateSortItem = ['price', 'createdAt', 'updatedAt'];

  const offeringTypeFilter = offeringTypeList.map((x: any) => ({
    text: x.tagName,
    value: x.id,
  }));

  const tagFilter = ingredient.map((x: any) => ({
    text: x.tagName,
    value: x.id,
  }));

  const getSortOrder = (key: any) => {
    if (sortItem && sortItem.sortedBy === key) {
      return sortItem.sortedOrder;
    }
    return false;
  };

  return [
    {
      title: tx('Global.product_name'),
      width: 200,
      dataIndex: 'name',
      key: 'name',
      // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      ellipsis: true,
      fixed: 'left',
    },
    { ...stock },
    {
      ...publish,
      sorter: true,
      sortDirections: ['ascend', 'descend', false],
      sortOrder: getSortOrder('published'),
    },
    {
      title: tx('Global.price'),
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (item: any) => (item ? `$ ${item}` : ''),
      sorter: true,
      sortDirections: ['ascend', 'descend', false],
      sortOrder: getSortOrder('price'),
    },
    {
      title: tx('Global.offering_type'),
      dataIndex: 'offeringType',
      key: 'offeringType',
      width: 180,
      filters: offeringTypeFilter,
      filteredValue: filter && filter.offeringType ? filter.offeringType : [],
    },
    {
      title: tx('Global.menu'),
      dataIndex: 'menu',
      key: 'menu',
      width: 150,
      ellipsis: true,
      render: (item: any) => item.join(', '),
    },
    {
      title: tx('Global.recommend'),
      dataIndex: 'isRecommended',
      key: 'isRecommended',
      width: 150,
      // filters: [
      //   {
      //     text: 't_true',
      //     value: 'true',
      //   },
      //   {
      //     text: 't_false',
      //     value: 'false',
      //   },
      // ],
      // onFilter: (value: any, record: any) => [record.isRecommended].indexOf(value) >= 0,
      // sorter: (a: any, b: any) => a.isRecommended.localeCompare(b.isRecommended),
    },
    {
      title: tx('Global.tag'),
      dataIndex: 'tag',
      key: 'tag',
      width: 150,
      // filters: tagFilter,
      render: (tag: any) => tag.join(', '),
      // filters: tagFilter,
      // filteredValue: filter && filter.tag ? filter.tag : [],
    },
    {
      title: tx('Global.created_at'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: (time: string) => getDateAndTimeFormat(time),
      // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
      sorter: true,
      sortDirections: ['ascend', 'descend', false],
      sortOrder: getSortOrder('createdAt'),
    },
    {
      title: tx('Global.updated_at'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 150,
      render: (time: string) => getDateAndTimeFormat(time),
      // sorter: (a: any, b: any) => a.updatedAt.localeCompare(b.updatedAt),
      sorter: true,
      sortDirections: ['ascend', 'descend', false],
      sortOrder: getSortOrder('updatedAt'),
    },
    {
      ...actionButton,
    },
  ];
};
